import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from '@shared/components/ui/shadcn/avatar';
import { cn } from '@shared/utils/utils';

interface UserAvatarProps {
  image?: string;
  name: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  'data-testid'?: string;
}

const sizeClasses = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-12 h-12 text-sm',
  lg: 'w-[92px] h-[92px] text-xl',
};

export const UserAvatar = ({
  image,
  name,
  size = 'md',
  className,
  'data-testid': testId = 'user-avatar',
}: UserAvatarProps) => {
  const initials = name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  return (
    <Avatar className={cn(sizeClasses[size], className)} data-testid={testId}>
      <AvatarImage src={image} alt={name} />
      <AvatarFallback className="bg-card-border">{initials}</AvatarFallback>
    </Avatar>
  );
};
